<app-page-header-png [isCurveGray]="true" header={{language.jobspagename}} backgroundPath="assets/images/lead/bg.jpg">
</app-page-header-png>

<div class="container">
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 text-center">
            <h1>{{language.jobtitle}}</h1>

            <!-- contant -->
            <div class="col-lg-12 col-md-12 col-sm-12 text-center mb-5" *ngFor="let items of JobList; let i = index">
                <div *ngIf="flag == 'th'; else elseJobList">
                    <div class="row" *ngIf="items.id != '' " class="{{isCollapse ? 'collapsed': ''}}">
                        <app-collapse-job header="{{items.positionname}}">
                            <div class="col-lg-12 col-md-12 col-sm-12">
                                <div class="topic--menu">
                                    <h2 class="text-left pl-5 mt-4">{{language.jobsdetail}}</h2>
                                    <div class="pl-5" style="color: #395e77;">
                                        <div class="job-description text-left pl-2" [innerHTML]="items.details_work">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12  mb-3">
                                <app-button text="{{language.btn7}}" (click)="Detail(items.id)" class="float-center">
                                    <button class="button--primary">
                                        <span>
                                            <a>Apply</a>
                                        </span>
                                    </button>
                                </app-button>
                            </div>
                        </app-collapse-job>
                        <!-- <div class="col-lg-10 col-md-10 col-sm-12">
                            <h2 class="float-left  font-weight-bold text-left">{{items.positionname}}</h2>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="topic--menu">
                                <h2 class="text-left pl-5 mt-4">{{language.jobsdetail}}</h2>
                                <div class="pl-5" style="color: #395e77;">
                                    <div class="job-description text-left pl-2" [innerHTML]="items.details_work"></div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  mb-3">
                            <app-button text="{{language.btn7}}" (click)="Detail(items.id)" class="float-center">
                                <button class="button--primary">
                                    <span>
                                        <a>Apply</a>
                                    </span>
                                </button>
                            </app-button>
                        </div> -->
                    </div>
                </div>
                <ng-template #elseJobList>
                    <div class="row" *ngIf="items.id != '' " class="{{isCollapse ? 'collapsed': ''}}">
                        <app-collapse-job header="{{items.positionname_en}}">
                            <div class="col-lg-12 col-md-12 col-sm-12">
                                <div class="topic--menu">
                                    <h2 class="text-left pl-5 mt-4">{{language.jobsdetail}}</h2>
                                    <div class="pl-5" style="color: #395e77;">
                                        <div class="job-description text-left pl-2" [innerHTML]="items.details_work_en">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12  mb-3">
                                <app-button text="{{language.btn7}}" (click)="Detail(items.id)" class="float-center">
                                    <button class="button--primary">
                                        <span>
                                            <a>Apply</a>
                                        </span>
                                    </button>
                                </app-button>
                            </div>
                        </app-collapse-job>
                    </div>
                </ng-template>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 text-center mb-5" *ngFor="let items of JobList; let i = index">
                <div class="row" *ngIf="items.id == '' ">
                    <div class="col-lg-12 col-md-12 col-sm-12">
                        <h2 class="text-center">-{{language.jobsnull}}-</h2>
                    </div>
                </div>
            </div>
            <!-- contant -->

        </div>